import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyAuthappComponent } from './verify-authapp.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    VerifyAuthappComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule
  ]
})
export class VerifyAuthappModule { }
